module.exports = __webpack_public_path__ + "static/audiA8-4f23324bb15398d2b5a596b7f1a06b39.png";